import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=74eb2803&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=74eb2803&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eb2803",
  null
  
)

export default component.exports